import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'verify-email',
        path: `${AUTH_PREFIX_PATH}/verify-email`,
        component: React.lazy(() => import('views/auth-views/authentication/verify-email')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'novidades.default',
        path: `${APP_PREFIX_PATH}/novidades/default`,
        component: React.lazy(() => import('views/app-views/novidades/default')),
    },
    {
        key: 'monitoramento.default',
        path: `${APP_PREFIX_PATH}/monitoramento/default`,
        component: React.lazy(() => import('views/app-views/monitoramento/default')),
    },
    {
        key: 'dashboard-checklists.default',
        path: `${APP_PREFIX_PATH}/dashboards-checklists/default`,
        component: React.lazy(() => import('views/app-views/dashboards-checklists/default')),
    },
    {
        key: 'cliente.default',
        path: `${APP_PREFIX_PATH}/cliente/default`,
        component: React.lazy(() => import('views/app-views/cliente/default')),
    },
    {
        key: 'gestao-acesso.default',
        path: `${APP_PREFIX_PATH}/gestao-acesso/default`,
        component: React.lazy(() => import('views/app-views/gestao-acesso/default')),
    },
    {
        key: 'chamados.default',
        path: `${APP_PREFIX_PATH}/chamados/default`,
        component: React.lazy(() => import('views/app-views/chamados/default')),
    },
    {
        key: 'revenda.default',
        path: `${APP_PREFIX_PATH}/revenda/default`,
        component: React.lazy(() => import('views/app-views/revenda/default')),
    },
    {
        key: 'cliente.default',
        path: `${APP_PREFIX_PATH}/veiculo/default`,
        component: React.lazy(() => import('views/app-views/veiculo/default')),
    },
    {
        path: `${APP_PREFIX_PATH}/rastreamento/default`,
        component: React.lazy(() => import('views/app-views/rastreamento/default')),
    },
    {
        key: 'cliente.default',
        path: `${APP_PREFIX_PATH}/rastreador/default`,
        component: React.lazy(() => import('views/app-views/rastreador/default')),
    },
    {
        key: 'cliente.default',
        path: `${APP_PREFIX_PATH}/contrato/default`,
        component: React.lazy(() => import('views/app-views/contrato/default')),
    },
    {
        key: 'contrato.wizard.novo',
        path: `${APP_PREFIX_PATH}/contrato/wizard`,
        component: React.lazy(() => import('views/app-views/contrato/wizard')),
    },
    {
        key: 'contrato.wizard.editar',
        path: `${APP_PREFIX_PATH}/contrato/wizard/:id`,
        component: React.lazy(() => import('views/app-views/contrato/wizard')),
    },
    {
        key: 'checklist.default',
        path: `${APP_PREFIX_PATH}/checklist/default`,
        component: React.lazy(() => import('views/app-views/checklist/default')),
    },
    {
        key: 'push.default',
        path: `${APP_PREFIX_PATH}/push/default`,
        component: React.lazy(() => import('views/app-views/push/default')),
    },
    {
        key: 'novidades.default',
        path: `${APP_PREFIX_PATH}/novidados/default`,
        component: React.lazy(() => import('views/app-views/novidades/default')),
    },
    {
        key: 'notificacao.default',
        path: `${APP_PREFIX_PATH}/notificacao/default`,
        component: React.lazy(() => import('views/app-views/notificacao/default')),
    },
    {
        key: 'sms.default',
        path: `${APP_PREFIX_PATH}/sms/default`,
        component: React.lazy(() => import('views/app-views/sms/default')),
    },
    {
        key: 'whatsapp.configuracao',
        path: `${APP_PREFIX_PATH}/whatsapp/configuracao`,
        component: React.lazy(() => import('views/app-views/whatsapp/configuracao')),
    },
    {
        key: 'ses.default',
        path: `${APP_PREFIX_PATH}/ses/default`,
        component: React.lazy(() => import('views/app-views/ses/default')),
    },
    {
        key: 'config.default',
        path: `${APP_PREFIX_PATH}/configuracao/default`,
        component: React.lazy(() => import('views/app-views/configuracao/default')),
    },
    {
        key: 'empresa.default',
        path: `${APP_PREFIX_PATH}/empresa/default`,
        component: React.lazy(() => import('views/app-views/empresa/default')),
    },
    {
        key: 'cadastro-pendente.default',
        path: `${APP_PREFIX_PATH}/cadastro-pendente/default`,
        component: React.lazy(() => import('views/app-views/cadastro-pendente')),
    },
    {
        key: 'boleto.default',
        path: `${APP_PREFIX_PATH}/boleto/default`,
        component: React.lazy(() => import('views/app-views/boleto/default')),
    },
    {
        key: 'instalador.default',
        path: `${APP_PREFIX_PATH}/instalador/default`,
        component: React.lazy(() => import('views/app-views/instalador/default')),
    },
    {
        key: 'extrato.default',
        path: `${APP_PREFIX_PATH}/extrato/default`,
        component: React.lazy(() => import('views/app-views/extrato/default')),
    },
    {
        key: 'extrato.resumo',
        path: `${APP_PREFIX_PATH}/extrato/resumo`,
        component: React.lazy(() => import('views/app-views/extrato/resumo')),
    },
    {
        key: 'extrato.movimentos',
        path: `${APP_PREFIX_PATH}/extrato/movimentos`,
        component: React.lazy(() => import('views/app-views/extrato/movimentos')),
    },
    {
        key: 'extrato.faturas',
        path: `${APP_PREFIX_PATH}/extrato/faturas`,
        component: React.lazy(() => import('views/app-views/extrato/faturas')),
    },
    {
        key: 'manual.tipo',
        path: `${APP_PREFIX_PATH}/manual/:tipo`,
        component: React.lazy(() => import('views/app-views/manual')),
    },
    {
        key: 'manual.default',
        path: `${APP_PREFIX_PATH}/manual`,
        component: React.lazy(() => import('views/app-views/manual')),
    }
]